// extracted by mini-css-extract-plugin
module.exports = {"wrappRadio":"RadioButtonsGroupMoons_wrappRadio__3U8sw","label":"RadioButtonsGroupMoons_label__1JTyY"};